import React from 'react'
import { IoLibraryOutline } from 'react-icons/io5'
import { LiaToolsSolid } from 'react-icons/lia'
import { LiaShapesSolid } from 'react-icons/lia'
import { MdOutlineEscalatorWarning } from 'react-icons/md'

const sections = [
  {
    icon: (
      <LiaShapesSolid
        className="Seconde_icon_bg p-2 rounded"
        size="40px"
        color="white"
      />
    ),
    title: 'Continuous Innovation',
    description:
      'We remain at the forefront of educational innovation, constantly evolving our services to offer the latest in E-learning technology and methodologies, ensuring a cutting-edge learning experience.',
  },
  {
    icon: (
      <IoLibraryOutline
        className="Seconde_icon_bg p-2 rounded"
        size="40px"
        color="white"
      />
    ),
    title: 'Tailored Curriculum',
    description:
      'We curate specialized learning paths, tailored to meet diverse educational needs, ensuring a comprehensive and enriching experience for all learners.',
  },
  {
    icon: (
      <LiaToolsSolid
        className="Seconde_icon_bg p-2 rounded"
        size="40px"
        color="white"
      />
    ),
    title: 'Interactive Learning Tools',
    description:
      'Our platform incorporates state-of-the-art interactive tools, fostering engaging and immersive learning experiences that captivate and inspire.',
  },
  {
    icon: (
      <MdOutlineEscalatorWarning
        className="Seconde_icon_bg p-2 rounded"
        size="40px"
        color="white"
      />
    ),
    title: 'Expert Guidance',
    description:
      'Learners benefit from expert guidance and support, ensuring they navigate through courses with clarity and confidence, backed by our experienced educators.',
  },
]

function Seconde_Component() {
  return (
    <>
      <style>{`
        .Seconde_comp{
        background-color:rgb(239, 240, 255,0.4);
        border-radius:20px;
        }
        .Seconde_comp h6{
        font-family:"Poppins", sans-serif;
        font-size:15px;
        user-select: none;
        }
        .Seconde_comp p{
        font-size:10px;
        color: var(--color-grey-darken-2);
        font-family:"Poppins", sans-serif;
        user-select: none;
        }
        .Seconde_comp_text h2{
        color:#2b1c50;
        font-family:"Poppins", sans-serif;
        user-select: none;
        }
        .Seconde_comp_text p{
        color: var(--color-grey-darken-2);
        font-family:"Poppins", sans-serif;
        font-size:0.9rem;
        user-select: none;
        }
        .mobile_Seconde_comp h6{
        font-family:"Poppins", sans-serif;
        font-size:15px;
        user-select: none;
        }
        .mobile_Seconde_comp p{
        font-size:10px;
        color: var(--color-grey-darken-2);
        font-family:"Poppins", sans-serif;
        user-select: none;
        }
        .mobile_Seconde_comp_text h2{
        color:#2b1c50;
        font-family:"Poppins", sans-serif;
        font-size:22px;
        user-select: none;
        }
        .mobile_Seconde_comp_text p{
        color: var(--color-grey-darken-2);
        font-family:"Poppins", sans-serif;
        font-size:12px;
        user-select: none;
        }
        .Seconde_icon_bg{
        background-color:#2b1c50;
        }
      `}</style>
      <div>
        {/* -------------------------------Mobile View-------------------------------- */}
        <div className="container-fluid pt-2 d-md-none d-sm-block">
          <div className="row">
            <div className="col-md-1"></div>
            <div className="col-md-5 mobile_Seconde_comp_text text-center px-3">
              <h2 className="py-2">
               Unlock Your Career Potential with Our Proven Educational Approach
              </h2>
              <p>
            InternsElite empowers learners with customized programs designed for diverse career paths. Our evolving curricula, expert mentorship, and engaging resources provide the skills and guidance you need to grow. At every stage, we support your journey toward career success.
              </p>
            </div>
            <div className="col-md-5 pt-2">
              <div className="mobile_Seconde_comp px-5 py-3 shadow">
                <div className="row">
                  {sections.map((section, index) => (
                    <div className="col-md-6 py-2" key={index}>
                      <h6>
                        {section.icon} {section.title}
                      </h6>
                      <p>{section.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-md-1"></div>
          </div>
        </div>
        {/* -------------------------------Desktop View-------------------------------- */}
        <div className="container-fluid d-md-block d-none pt-3">
          <div className="row">
            <div className="col-md-1"></div>
            <div className="col-md-5 Seconde_comp_text pt-5 px-3">
              <h2 className="py-2">
                Unlock Your Career Potential with Our Proven Educational Approach
              </h2>
              <p>
                InternsElite empowers learners with customized programs designed for diverse career paths. Our evolving curricula, expert mentorship, and engaging resources provide the skills and guidance you need to grow. At every stage, we support your journey toward career success.
              </p>
            </div>
            <div className="col-md-5">
              <div className="Seconde_comp px-5 py-5 shadow">
                <div className="row">
                  {sections.map((section, index) => (
                    <div
                      className={`col-md-6 ${index >= 2 ? 'pt-4' : ''}`}
                      key={index}
                    >
                      <h6>
                        {section.icon} {section.title}
                      </h6>
                      <p>{section.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-md-1"></div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Seconde_Component
